import Config from "../Config";
import Requisicao from "./RequisicaoService";

class CupomService {
    static async listar(documentoCliente) {
        return Requisicao.post(Config.urlBaseApi + 'cupons', {documentoCliente : documentoCliente});
    }    
}

export default CupomService;